<div class="row">
    <div class="col-sm-12">
        <core-card [actions]="['collapse']">
            <h4 class="card-title">{{'Ticket' | translate}}</h4>
            <div class="card-body">
                <form class="form">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="search">{{'Search' | translate}}</label>
                                <input type="search" class="form-control form-control-sm" id="search" name="search"
                                    placeholder="{{'Search' | translate}}" [(ngModel)]="getTicketsInput.searchText" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="date">{{'FromDate' | translate}}</label>
                                <ng2-flatpickr [config]="dateOptions" name="fromDateSearch" id="fromDateSearch"
                                    [(ngModel)]="fromDateSearch" [setDate]="fromDateSearch2">
                                </ng2-flatpickr>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="date">{{'ToDate' | translate}}</label>
                                <ng2-flatpickr [config]="dateOptions" name="toDateSearch" id="toDateSearch"
                                    [(ngModel)]="toDateSearch" [setDate]="toDateSearch2">
                                </ng2-flatpickr>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label" for="ticketStatus">{{'Status' | translate}}</label>
                                <!-- <select class="form-control form-control-sm" id="ticketStatus" name="ticketStatus"
                                    [(ngModel)]="getTicketsInput.ticketStatus">
                                    <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                                    </option>
                                    <option *ngFor="let enumItem of ticketStatus | enumKey" [ngValue]="enumItem.key">
                                        {{enumItem.value | translate}}
                                    </option>
                                </select> -->
                                <ng-select [virtualScroll]="true" id="tagDropdownMulti" name="tagDropdownMulti"
                                    [items]="ticketStatus | enumKey" class="ng-select-size-sm" [(ngModel)]="getTicketsInput.ticketStatus"
                                    bindLabel="value" bindValue="key" [multiple]="true" [closeOnSelect]="false"
                                    [hideSelected]="true">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label" for="priority">{{'Priority' | translate}}</label>
                                <select class="form-control form-control-sm" id="priority" name="priority"
                                    [(ngModel)]="getTicketsInput.priority">
                                    <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                                    </option>
                                    <option *ngFor="let enumItem of priorityEnum | enumKey" [ngValue]="enumItem.key">
                                        {{enumItem.value | translate}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <div class="form-group">
                                <label class="form-label" for="customerId">{{'Customer' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="customerId" name="customerId"
                                    class="ng-select-size-sm" [items]="customerList"
                                    [(ngModel)]="getTicketsInput.customerId" bindLabel="name" bindValue="id"
                                    (change)="getProjectsWithCustomerId()">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label" for="projectId">{{'Project' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="projectId" name="projectId"
                                    class="ng-select-size-sm" [items]="projectList"
                                    [(ngModel)]="getTicketsInput.projectId" bindLabel="name" bindValue="id">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="form-label" for="allProjectId">{{'AllProjects' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="allProjectId" name="allProjectId"
                                    class="ng-select-size-sm" [items]="allProjectList"
                                    [(ngModel)]="getTicketsInput.allProjectId" bindLabel="name" bindValue="id">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <div class="form-group">
                                <label class="form-label" for="tagDropdownMulti">{{'Tag' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="tagDropdownMulti" name="tagDropdownMulti"
                                    [items]="tagList" class="ng-select-size-sm" [(ngModel)]="getTicketsInput.tagIds"
                                    bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false"
                                    [hideSelected]="true">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <label for="task-assigned" class="form-label d-block">{{'Employee'|
                                translate}}</label>
                            <ng-select [virtualScroll]="true" [items]="employeeDropdown" [disabled]="isSelectedEmployee" name="selectAssignee"
                                [(ngModel)]="getTicketsInput.assignedEmployeeId" bindLabel="fullName" bindValue="id"
                                class="ng-select-size-sm">
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="media align-items-center">
                                        <img class="d-block rounded-circle mr-50"
                                            *ngIf="item.personalPictureFileName !== ''"
                                            src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}"
                                            height="26" width="26" [alt]="item.fullName" />
                                        <img class="d-block rounded-circle mr-50"
                                            *ngIf="item.personalPictureFileName === ''" src="assets/images/avatar.png"
                                            height="26" width="26" [alt]="item.fullName" />
                                        <div class="media-body">
                                            <p class="mb-0">{{ item.fullName }}</p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-md-4" *ngIf="token === 'dashboardToken'">
                            <div class="form-group">
                                <label class="form-label" for="Dropdown">{{'TicketType' | translate}}</label>
                                <ng-select [virtualScroll]="true" id="tagDropdownMulti" name="tagDropdownMulti"
                                    [items]="ticketTypeResultList.data" class="ng-select-size-sm" [(ngModel)]="getTicketsInput.ticketType"
                                    bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false"
                                    [hideSelected]="true">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-12">
                            <button type="submit" rippleeffect=""
                                class="btn btn-primary mr-1 mt-1 mb-1 waves-effect waves-float waves-light"
                                (click)="loadData()">{{'Search' | translate}}</button>
                            <button type="submit" rippleeffect=""
                                class="btn btn-warning mr-1 mt-1 mb-1 waves-effect waves-float waves-light"
                                (click)="downloadExcel()">{{'Excel' | translate}}</button>
                        </div>
                        
                    </div>
                </form>
                <div class="table-responsive">
                    <table class="table table-sm table-hover deneme">
                        <thead>
                            <tr>
                                <ng-container *ngFor="let item of tableHeaders">
                                    <th class="text-center" (click)="onSortChange(item.key)">{{item.title | translate}}
                                        <i *ngIf="item.isSortable == true && item.key == getTicketsInput.sortType"
                                            class="fa" [ngClass]="{'fa-chevron-up' : (getTicketsInput.sortOrder == sortOrder.Ascending),
                                        'fa-chevron-down' : (getTicketsInput.sortOrder == sortOrder.Descending)}"></i>
                                    </th>
                                </ng-container>
                                <th class="text-center">{{'Actions' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of ticketResultList.data" ngClass="lastComment{{item.lastComment}}">
                                <td class="text-center">{{item.id}}</td>
                                <td class="text-center">{{item.title}}</td>
                                <td class="text-center">{{item.customerName}}</td>
                                <td class="text-center">{{item.projectName}}</td>
                                <td class="text-center">{{priority[item.priority] | translate}}</td>
                                <td class="text-center">{{ticketStatus[item.ticketStatus] | translate}}</td>
                                <td class="text-center">{{item.creationDateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}}
                                </td>
                                <td class="text-center">{{item.creatorUserFullName}}</td>
                                <td class="text-center">{{item.assignedEmployeeFullName}}</td>
                                <td class="text-center">{{item.editDateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}}</td>
                                <td class="text-center" *ngIf="token === 'dashboardToken'">{{item.ticketTypeName}}</td>
                                <td class="text-center">
                                    <button [disabled]="isBusy == true" type="button" tooltipClass="fadeInAnimation"
                                        placement="top" ngbTooltip="{{'TicketHistory' | translate}}"
                                        (click)="demonstrateTicketHistory(ticketHistoryModal, item.id)"><i
                                            class="fa fa-history"></i></button>
                                    <button [disabled]="isBusy == true" type="button" tooltipClass="fadeInAnimation"
                                        placement="top" ngbTooltip="{{'TicketDetail' | translate}}"
                                        (click)="showComments(ticketCommentModal,item)"><i class="fa fa-eye"></i></button>
                                    <button [disabled]="isBusy == true" type="button" tooltipClass="fadeInAnimation"
                                        placement="top" ngbTooltip="{{'AssignedEmployee' | translate}}"
                                        (click)="assignedEmployeeHistory(assignedEmployeeModal, item.customerId)"><i
                                            class="fa fa-user"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <app-pagination [disabled]="isBusy" [paginationInformation]="ticketResultList.paginationInformation"
                    (pageChange)="onPageChange($event)">
                </app-pagination>
            </div>
        </core-card>
        <!-- <div id="ticketComment">
            <app-ticket-comment [ticketInput]="ticket!" [token]="token" [employeeDropdown]="employeeDropdown"
                (assignedChanged)="loadData()" (ticketHasChanged)="onTicketHasChanged($event)"></app-ticket-comment>
        </div> -->
    </div>
</div>
<ng-template #ticketHistoryModal let-modal >
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'TicketHistory' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-ticket-history [id]="ticketIdForHistory" [isBusy]="isBusy"></app-ticket-history>
    </div>
</ng-template>


<ng-template #ticketCommentModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'TicketComment' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div id="ticketComment">
        <app-ticket-comment [ticketInput]="ticket!" [token]="token" [employeeDropdown]="employeeDropdown"
            (assignedChanged)="loadData()" (ticketHasChanged)="onTicketHasChanged($event)"></app-ticket-comment>
    </div>
</ng-template>


<ng-template #assignedEmployeeModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'AssignedEmployee' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-ticket-assigned-employee [id]="clientIdForAssignedEmployee" [isBusy]="isBusy"></app-ticket-assigned-employee>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>